import { AudioLines, Captions, Music2, Volume2, X, ZapOff } from 'lucide-react';
import { useGame } from '../game/GameContext';

export function SettingsOverlay() {
  const { state, dispatch } = useGame();
  const levels = [
    { channel: 'master' as const, label: 'Master', icon: Volume2 },
    { channel: 'music' as const, label: 'Score', icon: Music2 },
    { channel: 'voice' as const, label: 'Voices', icon: AudioLines },
    { channel: 'sfx' as const, label: 'Effects', icon: ZapOff },
  ];

  return (
    <div className="overlay-backdrop screen-layer">
      <section className="settings-panel panel-surface">
        <header>
          <span>SYSTEM / AUDIO + ACCESSIBILITY</span>
          <h2>Experience</h2>
          <button className="icon-action" onClick={() => dispatch({ type: 'CLOSE_OVERLAY' })}><X /></button>
        </header>

        <button onClick={() => dispatch({ type: 'TOGGLE_MUTE' })}>
          <Volume2 />
          <span><strong>All sound</strong><small>Procedural score, voiced testimony and courtroom foley</small></span>
          <i className={!state.muted ? 'is-on' : ''} />
        </button>

        <div className="audio-mixer">
          {levels.map(({ channel, label, icon: Icon }) => (
            <label key={channel}>
              <Icon />
              <span>{label}</span>
              <input
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={state.audio[channel]}
                onChange={(event) => dispatch({ type: 'SET_AUDIO_LEVEL', channel, value: Number(event.target.value) })}
              />
              <strong>{Math.round(state.audio[channel] * 100)}</strong>
            </label>
          ))}
        </div>

        <button onClick={() => dispatch({ type: 'TOGGLE_SUBTITLES' })}>
          <Captions />
          <span><strong>Spoken subtitles</strong><small>Shows voiced dialogue and live court event captions</small></span>
          <i className={state.audio.subtitles ? 'is-on' : ''} />
        </button>
        <button onClick={() => dispatch({ type: 'TOGGLE_REDUCED_MOTION' })}>
          <ZapOff />
          <span><strong>Reduced motion</strong><small>Disables camera shake, drift and bloom</small></span>
          <i className={state.reducedMotion ? 'is-on' : ''} />
        </button>
      </section>
    </div>
  );
}
